import React, {useState, useEffect} from 'react';
import {Input} from 'reactstrap';
import {Button} from '@mui/material';
import {useLocation, useNavigate} from "react-router-dom";
import moment from 'moment';
import * as Apis from "Api";
import QueryString from "query-string";
import SchoolIcon from "@mui/icons-material/School";
import {NotificationManager} from "react-notifications";

function CompletedComponent() {
    const navigate = useNavigate();
    const location = useLocation();
    const [completeList, setCompleteList] = useState([]);
    const [totalAttempt, setTotalAttempt] = useState(0);
    const [totalPoint, setTotalPoint] = useState(0);
    const [selectedTestSet, setSelectedTestSet] = useState(null);
    const [attemptList, setAttemptList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [searchType, setSearchType] = useState('');
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        getData(true);
    }, []);

    useEffect(() => {
        if (selectedTestSet) {
            Apis.attemptsCompletedList(selectedTestSet.id).then(resp => {
                setAttemptList(resp.attempts);
                navigate(QueryString.stringifyUrl({url: location.pathname, query: {tab: 'completed', id: selectedTestSet.id}}), {replace: true});
            }).catch(e => {

            });

        } else {
            setAttemptList([]);
            navigate(QueryString.stringifyUrl({url: location.pathname, query: {tab: 'completed'}}), {replace: true});
        }
    }, [selectedTestSet]);

    const getData = (firstLoading) => {
        Apis.testSetRecentlyCompleted().then((resp) => {
            let a = 0, p = 0;
            const types = [];
            resp.forEach((v) => {
                a += v.attemptCount;
                p += v.test_set_point;
                if (v.modalityInfo.modality_type === 'quiz') {
                    v.type = 'Quiz';
                } else if (['video_lecture', 'presentations', 'interactive_video'].indexOf(v.modalityInfo.modality_type) !== -1) {
                    v.type = 'LECTURE';
                } else if (v.modalityInfo.modality_type === 'viewer') {
                    v.type = 'IMAGE VIEWER';
                } else {
                    v.type = 'SELF ASSESSMENT MODULE';
                }
                if (!types.includes(v.type)) types.push(v.type);
            });
            setTotalAttempt(a);
            setTotalPoint(p);
            setCompleteList(resp);
            setTypeList(types);
            if (firstLoading) {
                const param = QueryString.parse(location.search);
                if (param.id) {
                    const selectedItem = resp.find((v) => v.id === param.id);
                    if (selectedItem) setSelectedTestSet(selectedItem);
                }
            }
        })
    }

    const onReattempt = () => {
        Apis.attemptsStart(selectedTestSet.id, undefined).then(attempt => {
            let path;
            if (attempt.progress === 'test') {
                path = (['video_lecture', 'presentations', 'interactive_video'].indexOf(attempt.modality_type) === -1 ? '/test-view/' : '/video-view/') + attempt.test_set_id + '/' + attempt.id + '/' + attempt.current_test_case_id;
            } else {
                path = '/main/attempt/' + attempt.id + '/' + attempt.progress;
            }
            navigate(path)
        });
    }

    const onGetCertPdf = (type, attemptInfo) => {
        Apis.attemptsCertificatePdf(attemptInfo.id, type, null, selectedTestSet.name).then((resp) => {
        }).catch((e) => {
            NotificationManager.error(e.response ? e.response.data.error.message : e.message);
        });
    }

    const renderCompletedLine = (v) => {
        const color = v.modalityInfo.modality_color || '#534ed9';
        return (
            <tr style={{backgroundColor: color}} key={v.id}>
                <td>{v.name}</td>
                <td><span style={{color: color}}>{v.type}</span></td>
                <td>{v.test_set_code}</td>
                <td className={'text-center'}>{v.test_set_point}</td>
                <td className={'text-center'}>{v.attemptCount}</td>
                <td>
                    <Button onClick={() => setSelectedTestSet(v)}>
                        <span style={{color: color}}>CONTINUE</span>
                    </Button>
                </td>
            </tr>
        )
    }

    const renderCompleteData = () => {
        let rowData = completeList;
        if (searchType) rowData = rowData.filter((v) => v.type === searchType);
        if (searchText) rowData = rowData.filter((v) => v.name?.toLowerCase().includes(searchText.toLowerCase()) || v.test_set_code?.toLowerCase().includes(searchText.toLowerCase()));
        return rowData.map((v) => renderCompletedLine(v))
    }

    const renderAttemptLine = (attemptInfo, i) => {
        return (
            <tr key={attemptInfo.id} style={{backgroundColor: (selectedTestSet.modalityInfo.modality_color || '#534ed9')}}>
                <td className={'text-center'}>{i + 1}</td>
                <td className={'text-center'}>{moment(attemptInfo.created_at).format('MM/DD/YYYY')}</td>
                <td className={'text-center'}>{moment(attemptInfo.updated_at).format('MM/DD/YYYY')}</td>
                <td>
                    {
                        selectedTestSet.modalityInfo.modality_type === 'presentations' ?
                            <Button
                                onClick={() => onGetCertPdf('normal', attemptInfo)}
                            >
                                <SchoolIcon className={'me-1'}/>
                                Certificate of Completion
                            </Button> :
                            <Button className={'profile-attempt-view-btn'} onClick={() => navigate('/main/attempt/' + attemptInfo.id + '/score')}>
                                <img src={require('Assets/img/main/icon_eye.svg').default} alt={''}/>
                                VIEW
                            </Button>
                    }
                </td>
            </tr>
        )
    }

    if (selectedTestSet === null) {
        return (
            <div className={'profile-content flex-column fw-semi-bold'}>
                <div className={'profile-completed-content'}>
                    <div className={'profile-completed-top'}>
                        <div className={'d-flex flex-row align-items-center'}>
                            <div className={'fs-15 text-primary1 me-10'}>TYPE</div>
                            <Input type={'select'} value={searchType} onChange={(e) => setSearchType(e.target.value)}>
                                <option value={''}>ALL</option>
                                {typeList.map((v) => <option key={v} value={v}>{v}</option>)}
                            </Input>
                            <div className={'fs-15 text-primary1 ms-40 me-10'}>SEARCH</div>
                            <Input
                                type={'text'}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>
                        <div className={'fs-15 text-primary1 cursor-pointer'} onClick={() => Apis.testSetsCompletedPdf()}>
                            EXPORT TO PDF
                        </div>
                    </div>
                    <div className={'profile-completed-table'}>
                        <table>
                            <thead>
                            <tr>
                                <th>NAME</th>
                                <th>TYPE</th>
                                <th>MODULE</th>
                                <th className={'text-center'}>POINTS</th>
                                <th className={'text-center'}>ATTEMPTS</th>
                                <th>REPORT</th>
                            </tr>
                            </thead>
                            <tbody>
                            {renderCompleteData()}
                            </tbody>
                        </table>
                    </div>
                    <div className={'profile-completed-bottom fs-15'}>
                        <div className={'profile-completed-bottom-title'}>
                            <span>TOTAL</span>
                            <div className={'d-flex flex-row me-50'}>
                                <div className={'me-40 text-center'} style={{width: 70}}>POINTS</div>
                                <div className={'me-50 text-center'} style={{width: 70}}>ATTEMPTS</div>
                            </div>
                        </div>
                        <div className={'d-flex flex-row justify-content-end me-50'}>
                            <div className={'me-40 text-center'} style={{width: 70}}>{totalPoint}</div>
                            <div className={'me-50 text-center'} style={{width: 70}}>{totalAttempt}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={'profile-content flex-column fw-semi-bold'}>
                <div className={'profile-completed-content'}>
                    <div className={'profile-completed-top'}>
                        <div className={'d-flex flex-row align-items-center'}>
                            <div className={'d-flex flex-row align-items-center fs-15 text-primary1 me-40 cursor-pointer'} onClick={() => setSelectedTestSet(null)}>
                                <i className="zmdi zmdi-chevron-left fs-23 me-2"/>
                                BACK
                            </div>
                            <div className={'d-flex flex-row align-items-end'}>
                                <div className={'fs-23 me-20'}>{selectedTestSet.name}</div>
                                <div className={'fs-15 mb-1'}>{selectedTestSet.test_set_code}</div>
                            </div>
                        </div>
                        <div>
                            <Button className={'profile-complete-reattempt'} onClick={onReattempt}>REATTEMPT</Button>
                        </div>
                    </div>
                    <div className={'profile-attempt-table'}>
                        <table>
                            <thead>
                            <tr>
                                <th className={'text-center'}>ATTEMPT NUMBER</th>
                                <th className={'text-center'}>START DATE</th>
                                <th className={'text-center'}>END DATE</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                attemptList.map((v, i) => renderAttemptLine(v, i))
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default CompletedComponent;